import CircularProgress from '@mui/material/CircularProgress'
import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
import Image from 'next/image'
import { useRouter } from 'next/router'
import React, { Dispatch, memo, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { IEnum_Solution_Type } from 'src/graphql/generated/hooks'
import { removeAllCompares, saveSearchPagePath, updateCompareBySlug } from 'src/store/actions/compare'
import { AppState } from 'src/store/types'
import { CompareInfos } from 'src/store/types/compare'
import { CompareSolution } from 'src/types'
import { getSolutionsBySlugs } from 'src/utils/getSolutionsBySlugs'

import styles from '../CompareModalContent/CompareModalContent.module.css'

interface CompareModalContentProps {
  solutionType: IEnum_Solution_Type
  onClose: () => void
}

export const CompareModalContent: React.FC<CompareModalContentProps> = memo(({ onClose, solutionType }) => {
  const empty: CompareSolution = { logo: '', id: '', slug: '', solutionType }
  const [compares, setCompares] = useState<CompareSolution[]>([empty, empty, empty, empty, empty])
  const [realCnt, setRealCnt] = useState(0)
  const [isProgressing, setIsProgressing] = useState(false)
  const router = useRouter()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: Dispatch<any> = useDispatch()
  const compareInfos: CompareInfos = useSelector((state: AppState) => state.compareInfos)
  useEffect(() => {
    setIsProgressing(false)
    async function getCompareSolutions() {
      let tmpCompares: CompareSolution[] = []
      if (compareInfos.solutions.length > 0) {
        tmpCompares = await getSolutionsBySlugs(compareInfos.solutions, solutionType)
      }
      const realCnt = tmpCompares.length
      let cnt = tmpCompares.length
      while (cnt < 5) {
        const item: CompareSolution = empty
        tmpCompares.push(item)
        cnt++
      }
      setRealCnt(realCnt)
      setCompares(tmpCompares)
      setIsProgressing(false)
    }

    getCompareSolutions()
  }, [compareInfos])

  const handleClose = () => {
    onClose()
  }

  const handleRemoveVendor = (item: CompareSolution) => {
    dispatch(updateCompareBySlug(item, true))
  }

  const handleRemoveAllVendors = () => {
    dispatch(removeAllCompares())
  }

  const handleGoCompare = () => {
    const slugs: string[] = []
    compares.map((compare) => {
      compare.slug !== '' && slugs.push(`${compare.slug.split(',').join('%')}#${compare.solutionType}`)
    })

    dispatch(saveSearchPagePath(router.asPath))

    const params = slugs.join(',')
    router.push({ pathname: '/compare', query: { solutions: params } })
    dispatch(removeAllCompares())
  }
  return (
    <div className={styles.drawerContent}>
      <div className={cn('flex flex-row justify-between md:w-[800px] w-full', styles.modalHeader)}>
        <p className={cn('flex items-center ml-[30px]', styles.title)}>COMPARE</p>
        <div className="mr-[25px] flex items-center" onClick={handleClose}>
          <IonIcon name="chevron-down-outline" className="h-[16px] w-[10px] text-textdark text-[1.3rem]" />
        </div>
      </div>
      {isProgressing ? (
        <div className="flex w-full h-full items-center justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div className="flex md:flex-row flex-wrap justify-between pl-[30px] pr-[30px] pt-[15px] items-center">
          {compares.map((item: CompareSolution) => {
            return item.logo === '' || item.logo === undefined ? (
              <div className="flex md:w-[107px] md:h-[107px] w-[50px] h-[50px] relative">
                <div
                  className={cn(
                    'flex absolute bottom-0 left-0 bg-white rounded-[8px] md:w-[92px] md:h-[92px] w-[42px] h-[42px]',
                    styles.emptyRectangle,
                  )}
                />
              </div>
            ) : (
              <div className="flex md:w-[107px] md:h-[107px] w-[50px] h-[50px] relative">
                <div
                  className={cn(
                    'flex absolute bottom-0 left-0 bg-white rounded-[8px] md:w-[92px] md:h-[92px] w-[42px] h-[42px]',
                    styles.productRectangle,
                  )}
                >
                  <Image
                    src={item.logo || ''}
                    className="w-full h-full rounded-[8px]"
                    alt=""
                    priority
                    width={42}
                    height={42}
                  />
                </div>
                <div className="cursor-pointer absolute top-0 right-0" onClick={() => handleRemoveVendor(item)}>
                  <IonIcon name="close-circle" className="!h-[30px] !w-[30px]" />
                </div>
              </div>
            )
          })}
          <div className="flex md:flex-col flex-row justify-center items-center md:mt-0 mt-[20px]">
            <button className={styles.btnCompare} disabled={realCnt > 1 ? false : true} onClick={handleGoCompare}>
              <p className={styles.btnCompareTitle}>Compare</p>
            </button>
            <button
              className="bg-transparent h-[50px] w-[100px] text-textdark font-secondary text-[14px] font-[600] ml-[15px] md:ml-0 md:mt-[15px]"
              onClick={handleRemoveAllVendors}
            >
              <p className={styles.removeAllTitle}>Clear all</p>
            </button>
          </div>
        </div>
      )}
    </div>
  )
})
